<script setup lang="ts">
import '../../../../assets/theme/quiz_base.css'

import { computed, onBeforeUnmount } from 'vue';
import { TEXT } from '../../../../configs/text';
import { useI18n } from 'petite-vue-i18n';
import { UserRole } from '../../../../types/user';
import { CountdownType } from '../../../../types/assessment';
import { QuizAudioKey, QuizState } from '../../../../types/quiz';
import { useQuizStore, useUserStore } from '../../../../stores';
import { audioManager } from '../../../../utils/audioManager';

import StudentQuiz from './StudentQuiz.vue';
import TeacherQuiz from './TeacherQuiz.vue';
import TopScore from './components/TopScore.vue';
import Countdown from '../../../Assessment/Countdown.vue';
import Fullscreen from '../../../General/Fullscreen.vue';
import IclassQuizWaiting from './IclassQuizWaiting.vue';

const { t } = useI18n()
const user = useUserStore()
const quizStore = useQuizStore()
const quizLoadingText = computed<string>(() => {
    return quizStore.quizState === QuizState.ON_GOING && quizStore.curentQuestionIndex == 0 ? t(TEXT.count_start_quiz) : `${t(TEXT.question)} ${quizStore.curentQuestionIndex + 1}`
})

onBeforeUnmount(() => {
    audioManager.stop(QuizAudioKey.BGM)
    audioManager.stop(QuizAudioKey.SFX)
})

</script>

<template>
    <Fullscreen class="h-full">
        <div ref="iclassQuiz" class="transistion-all duration-300 w-full h-full rounded-lg overflow-hidden text-indigo-950 dark:text-white" :data-mode="quizStore.darkMode ? 'dark' : 'light'"
            :class="`bg-[url(/src/assets/imgs/quiz_detail_bg.png)] dark:bg-[url(/src/assets/imgs/quiz_detail_bg_dark.png)] bg-cover bg-bottom`" v-if="quizStore.quiz.id">
            <div class="relative h-full flex flex-col items-center justify-center">
                <IclassQuizWaiting v-if="quizStore.quizState === QuizState.NOT_STARTED" />

                <div class="w-full h-full flex flex-col gap-5 justify-center items-center bg-black/50 backdrop-blur-sm" v-if="quizStore.quizState === QuizState.ON_GOING && quizStore.isCountingDown">
                    <div class=" text-4xl text-orange-500 dark:text-white font-bold capitalize">{{ quizLoadingText }}
                    </div>
                    <Countdown :type="CountdownType.CIRCULAR" :duration="quizStore.countDownRemaining" @finished="quizStore.isCountingDown = false">
                    </Countdown>
                </div>

                <template v-if="quizStore.quizState === QuizState.ON_GOING && !quizStore.isCountingDown">
                    <TeacherQuiz v-if="user.userRole === UserRole.teacher"></TeacherQuiz>
                    <StudentQuiz v-if="user.userRole === UserRole.student"></StudentQuiz>
                </template>

                <template v-if="quizStore.quizState === QuizState.FINISHED && !quizStore.isCountingDown">
                    <TopScore></TopScore>
                </template>
            </div>
        </div>
    </Fullscreen>
</template>